import { toast } from "react-toastify";
import HttpClient from "./HttpClient";
import useStore from "../Screen/redux/store/useStore";
import { Toast } from "../Component/Toast";
import store from "../Screen/redux/store/store";
import { saveAlertMessage } from "../Screen/redux/slice/alertMessage";

const notify = (msg) => {
  if (msg) {
    Toast(msg);
    store.dispatch(saveAlertMessage(msg));
  }
};

// FOR ERROR HANDLE
const HandleException = (err) => {
  // // console.log("from HandleException", err);


  try {
    const resp = err?.response;
    if (resp?.data) {
      const { data, status } = resp;

      switch (status) {
        case 400:
          notify(data?.message || data?.detail || "Bad request");
          return data || {};
        case 401:
          notify("Please re-login to access");
          setTimeout(() => {
            localStorage.removeItem("token");
            sessionStorage.clear();
            window.location.href = "/";
          }, 2000);
          return {};
        case 423:
          notify("Your account has been deactivated. Contact support.");
          setTimeout(() => {
            localStorage.removeItem("token");
            sessionStorage.clear();
            window.location.href = "/";
          }, 2000);
          return {};
        case 403: {
          if (data?.overall_holiday) {
            const reason = data?.overall_reason || "";
            localStorage.setItem("reason", reason);
            useStore.getState().setHoliday("is_holiday", true);
            useStore.getState().setHoliday("reason", reason);
          }
          return data || {};
        }
        case 404:
          notify(data?.message || "No Record Found!");
          return {};
        default:
          notify(data?.message || "Something went wrong");
          return data || {};
      }
    } else {
      notify("Something went wrong or check your internet");
      return {};
    }
  } catch (error) {
    notify("Something went wrong or check your internet");
    return {};
  }
};

// ✅ Response formatter
const PrepareResponse = (res) => {
  if (res?.status >= 200 && res?.status < 300) {
    return res.data;
  }
  notify(res?.data?.message || "Unexpected error");
  return {};
};

//  POST METHOD
export const post = async (url, data) => {
  try {
    let res = await HttpClient.post(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

//PATCH METHOD
export const patch = async (url, data) => {
  try {
    let res = await HttpClient.patch(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

// GET METHOD
export const get = async (url, data) => {
  try {
    let res = await HttpClient.get(url);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

//PUT METHOD
export const put = async (url, data) => {
  try {
    let res = await HttpClient.put(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

// DELETE METHOD
export const deletes = async (url, data) => {
  try {
    let res = await HttpClient.delete(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

// // FILE IMAGE POST METHOD
// export const file_post = async (url, data) => {
//   try {
//     let res = await httpClientForm.post(url, data);
//     return PrepareResponse(res);
//   } catch (error) {
//     return HandleException(error);
//   }
// };
